import React from 'react';

const Object_Management = () => {
  return (
    <div >
      <h1>Object_Management</h1>
      <p>Placeholder component for: "Object Management"</p>
    </div>
  );
};

export default Object_Management;
